import { Icon } from "antd";
import * as React from "react";
import "./PlaceholderCard.css";

interface IPlaceholderCardProps {
  iconType: string;
  text: string;
}

export const PlaceholderCard: React.SFC<IPlaceholderCardProps> = (props) => {
    return (
        <div className="placeholder-card">
            <Icon type={props.iconType} className="last-session-icon" />
            <p className="last-session-text">{props.text}</p>
        </div>
    );
};
